import { zmw, dt } from "@/lib/api";
import { Card, StatusBadge, Table, useLoad } from "@/components/common";

export function MyPayments({ kind, title = "Payments I reported", reloadKey }) {
  const { data } = useLoad("/payment-reports/mine", [reloadKey]);
  const rows = (data || []).filter((r) => !kind || r.kind === kind);
  return (
    <Card title={title} tip="Every payment you tell us about shows here. 'Pending Verification' = we are checking. 'Confirmed' = added to your account. 'Rejected' = not found; the reason is shown." testid={`my-payments-${kind || "all"}`}>
      <Table rows={rows} empty="You have not reported any payments yet." cols={[
        { k: "date", h: "Sent on", r: (r) => dt(r.date) }, { k: "reference", h: "Transaction ID", r: (r) => <span className="font-mono text-xs">{r.reference}</span> },
        { k: "amount", h: "Amount", right: true, r: (r) => zmw(r.amount_minor) }, { k: "status", h: "Status", r: (r) => <StatusBadge status={r.status} /> },
        { k: "reason", h: "Note", r: (r) => <span className="text-xs text-rose-700">{r.reason}</span> }]} />
    </Card>
  );
}
